import { render } from "./designation.vue?vue&type=template&id=449be14e"
import script from "./designation.vue?vue&type=script&lang=js"
export * from "./designation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__